<!-- 地图 -->
<template>
  <div class="centerMapContent">
    <div id="centermap" ref="basicMapbox" :style="mapSize"></div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

import mapboxgl from 'mapbox-gl'
export default {
  name: 'centermap',
  props: {
    mapWidth: {
      type: String
    },
    mapHeight: {
      style: String
    }
  },
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      showLegend: true,
      hiddenLegend: false,
      map: null
    }
  },
  // 监听属性 类似于data概念
  computed: {
    mapSize() {
      let styleObj = {
        width: this.mapWidth,
        height: this.mapHeight
      }
      return styleObj
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 初始化mapbox
    init() {
      mapboxgl.accessToken = 'pk.eyJ1IjoibXdmOTIwNCIsImEiOiJjanZ3Mmp2OWUxbDg4NGJwbmd3Yng3bGd2In0.va67-85VjrsaXrVgAXMLfg'
      this.map = new mapboxgl.Map({
        container: this.$refs.basicMapbox, // 地图绑定的元素
        style: 'mapbox://styles/mwf9204/cjwiv4kfy1ma51co8psablxc9', // 地图样式
        pitch: 30, // 倾斜角度
        center: [120.537, 29.971], // 中心位置经纬度
        zoom: 8.9, // 放大指数
        attributionControl: false // 是否显示mapbox下方的地图控件信息
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.init()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.centerMapContent {
  width: 100%;
  height: 100%;
  position: relative;
}
#centermap {
  width: 100%;
  height: 845px;
  position: relative;
}
.mapboxgl-control-container {
  display: none;
}
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: rgba(162, 44, 25, 0.6);
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  height: 100%;
}
.row-bg {
  padding: 10px 0;
  position: absolute;
  width: 100%;
  height: 85px;
  top: 0;
}
.warn-name {
  width: 100%;
  height: 20px;
  text-align: center;
  color: #fff;
  margin: 0;
  padding: 15px 0;
}
.warn-num {
  width: 100%;
  height: 20px;
  text-align: center;
  color: #ffff00;
  font-size: 24px;
  margin: 0;
  padding: 5px 0;
  font-style: italic;
  font-weight: 900;
}
.row-legend {
  width: 185px;
  height: 290px;
  bottom: 0;
  top: auto;
  left: 10px;
}
.legend {
  height: 270px;
  background: none;
  background-image: url(../../assets/homepage_img/legend.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.legend-closed {
  width: 10px;
  height: 10px;
  padding: 0;
  line-height: 12px;
  position: absolute;
  color: #fff;
  top: 5px;
  right: 15px;
  cursor: pointer;
}
.show-legend {
  width: 15px;
  height: 15px;
  background: rgba(162, 44, 25, 0.8);
  background-image: url(../../assets/homepage_img/openLegend.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 265px;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
}
</style>
